module.exports = __webpack_public_path__ + "static/guild-member-9e5a75f474e785f061e2b0c51b6e0318.svg";